const dictionary = {
	'pt_BR': {
		messages: {
			cnpj: () => 'CNPJ inválido',
			cpf: () => 'CPF inválido',
			required: (field) => `O campo ${ field } é obrigatório.`
		}
	}
};

export default dictionary;



// WEBPACK FOOTER //
// ./sources/support/validator/dictionary.js